import { render } from "./layout-horizontal-single.vue?vue&type=template&id=618d9384&scoped=true"
import script from "./layout-horizontal-single.vue?vue&type=script&lang=js"
export * from "./layout-horizontal-single.vue?vue&type=script&lang=js"

import "./layout-horizontal-single.vue?vue&type=style&index=0&id=618d9384&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618d9384"]])

export default __exports__